export type CreateUrlWithUtmOptions = {
  /** 既定: nola-web */
  source?: string;
  /** 既定: direct */
  medium?: string;
  /**
   * true のとき既存の utm_* を set で上書きする。
   * false / 省略時は append（既存呼び出し互換）。
   */
  overwrite?: boolean;
};

const DEFAULT_UTM_SOURCE = "nola-web";
const DEFAULT_UTM_MEDIUM = "direct";

/**
 * URL に UTM パラメータを付与する。
 * 企画マッチング等で source/medium を変える場合は options で上書きする。
 */
export function createUrlWithUtmParams(
  url: string,
  utmCampaign: string,
  utmContent?: string,
  options?: CreateUrlWithUtmOptions
): string {
  const urlObject = new URL(url);
  const source = options?.source ?? DEFAULT_UTM_SOURCE;
  const medium = options?.medium ?? DEFAULT_UTM_MEDIUM;
  const apply = (key: string, value: string) => {
    if (options?.overwrite) {
      urlObject.searchParams.set(key, value);
    } else {
      urlObject.searchParams.append(key, value);
    }
  };

  apply("utm_source", source);
  apply("utm_medium", medium);
  apply("utm_campaign", utmCampaign);
  if (utmContent) {
    apply("utm_content", utmContent);
  }

  return urlObject.toString();
}

/**
 * microCMSのメディアリクエストの最適化のため、パラメータを追加
 * @param url
 * @param quality
 * @param format
 * @returns
 */
export function optimizeImage(url: string, quality = 50, format = "webp") {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}fm=${format}&q=${quality}`;
}
